import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { Page, Steps } from '../../../helbest';
import { _save_category_id } from '../../../store/actions/login_actions';
import CartItem from '../../components/CartItem/CartItem';
import CartFooter from './CartFooter/CartFooter';
import EmptyCart from './EmptyCart/EmptyCart';
import cart_selector from './selectors';
import Summery from './Summery/Summery';

const Cart = ({ login, cart, save_category_id }) => {
  useEffect(() => {
    if (login.category_id === 0) save_category_id(1);
    // eslint-disable-next-line
  }, []);

  return (
    <Page
      address="/"
      back
      className="page-cart"
      footer={<CartFooter cart={cart} isEmpty={cart.length === 0} />}
      headerFix
      logo
      mobileContainer
      showFooter
      title="سبد خرید">
      <Steps step={1} />

      {cart.length === 0 ? <EmptyCart /> : null}

      {cart.length > 0 ? (
        <section className="cart-page-body">
          <div className="cart-item-container">
            {cart.map((cart_item, cart_item_index) => (
              <CartItem key={cart_item_index} data={cart_item} />
            ))}
            <Summery />
          </div>
        </section>
      ) : null}
    </Page>
  );
};

Cart.propTypes = {
  login: PropTypes.object,
  cart: PropTypes.array,
  save_category_id: PropTypes.func
};

const mapStateToProps = (state) => ({
  login: state.Login,
  cart: cart_selector(state)
});

const mapDispatchToProps = (dispatch) => ({
  save_category_id: (category_id) => dispatch(_save_category_id(category_id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
